import config from '@/config'

export default {
  combine: {
    confirm_password: "Подтвердить пароль",
    change_password: "Изменить пароль",
    old_password: "Старый @:ui.password",
    new_password: "Новый @:ui.password",
    confirm_security_code: "Подтвердите @:ui.security_code",
    first_time_login: "Первый вход в систему",
    security_authentication: "Безопасная аутентификация",
    update_security: "Обновить безопасность",
    disable_security: "Отключить безопасность",
    add_account: "Добавить аккаунт",
    add_sub_account: "Добавить субаккаунт",
    edit_operator: "Редактировать оператора",
    edit_account: "Редактировать аккаунт",
    edit_member: "Редактировать участника",
    approve_ticket: "Одобрить заявку",
    reject_ticket: "Отклонить заявку",
    add_bank_account: "Добавить банковский счет",
    edit_bank_account: "Редактировать банковский счет",
    reset_threshold: "Сбросить порог",
    adjust_balance: "Корректировка баланса",
    adjust_member: "Корректировка участника",
    configure_bank_setting: "Настроить параметры банка",
    account_setup: "Настройка аккаунта",
    bank_transfer: "Банковский перевод",
    edit_bank_member: "Редактировать банковского участника",
    edit_ticket: "Редактировать заявку",
    edit_vip: "Редактировать VIP",
    knock_off_promo: "Удалить акцию",
    edit_authority: "Редактировать полномочия",
    reset_password: "Сбросить пароль",
    update_password: "Обновить пароль",
    member_summary: "Сводка по участнику",
    reply_review: "Ответить на отзыв",
    edit_affiliate: "Редактировать партнёра",
    edit_bank_affiliate: "Редактировать банк партнёра",
    approve_affiliate_ticket: "Одобрить заявку партнёра",
    check_free_spin: "Проверить бесплатные вращения",
    reject_affiliate_ticket: "Отклонить заявку партнёра",
    wallet_adjust: "Корректировка кошелька",
    update_comm_package: "Обновить комиссионный пакет",
    approve_affiliate: "Одобрить партнёра",
    sub_acc_detail_affiliate: "Детали субаккаунта партнёра",
    get_tac: "Получить OTP",
    add_coupon: "Добавить купон",
    update_coupon: "Обновить купон",
    issue_free_spin: "Выдать бесплатные вращения",
    get_bank_tac: "Получить банковский OTP",
    update_global_setting: "Обновить глобальные настройки",
    add_platform: "Добавить платформу",
    edit_platform: "Платформа редактирования",
    add_bank_group: "Добавить банковскую группу",
    edit_bank_group: "Edit Bank Group",
    update_maintenance_schedule: "Обновить график технического обслуживания",
    add_withdrawal_limit: "Добавить лимит на вывод средств",
    edit_withdrawal_limit: "Редактировать лимит вывода",
    add_campaign: "Добавить кампанию",
    edit_campaign: "Редактировать кампанию",
    add_promo_group: "Добавить группу продвижения",
    edit_promo_group: "Редактировать группу продвижения",
    update_team: "Команда обновления",
    update_result: "Обновить результат",
    insert_result: "Вставить результат",
    bet_list: "Список ставок",
    result_list: "Список результатов",
    add_promo: "Добавить продвижение",
    raise_deposit_ticket: "Поднять депозитный билет",
    bank_adjust: "Корректировка банка",
    promo_member_assign: "Назначение участника акции",
    bonus_issue: "Бонусная эмиссия",
    update_vip: "Обновить VIP",
    update_member_profile: "Обновить профиль участника",
    change_withdrawal_limit: "Изменить лимит вывода",
    change_bank_group: "«Смена банковской группы»",
    change_promotion_group: "Изменить группу продвижения",
    edit_promo_signup: "Редактировать регистрацию в промоакции",
    update_provider_bet_limit: "Обновить лимит ставок провайдера",
    update_bet_limit: "Обновить лимит ставки",
    update_member_bet_limit: "Обновить лимит ставок участника",
    edit_bank_account_group: "Редактировать группу банковских счетов",
    redeposit_ticket: "Билет на повторный депозит",
    edit_promotion_group: "Редактировать группу продвижения",
    edit_promotion_group_norm: "Управление продвижением в группе",
    get_inbox_list: "Получить список входящих сообщений",
    view_result_changes_detail: "Просмотр сведений об изменениях результатов",
    edit_promotion_signup: "Редактировать регистрацию в промоакции",
    edit_bet_limit: "Редактировать лимит ставки",
    edit_provider_game_off: "Edit Provider Game Off",
    edit_provider_rtp: "Редактировать RTP провайдера",
    get_rebate: "Получить рибейт",
    get_recent_deposit: "Получить недавний депозит",
    add_survey: "Добавить опрос",
    add_announcement_banner: "Добавить баннер объявления",
    edit_announcement_banner: "Редактировать баннер объявления",
    move_announcement_banner: "Переместить баннер объявления",
    add_promotion_banner: "Добавить рекламный баннер",
    edit_promotion_banner: "Редактировать рекламный баннер",
    move_promotion_banner: "Переместить рекламный баннер",
    add_slide_banner: "Добавить баннер слайда",
    edit_slide_banner: "Редактировать баннер слайда",
    move_slide_banner: "Переместить баннер слайда",
    add_seo_page: "Добавить SEO-страницу",
    edit_seo_page: "Редактировать SEO-страницу",
    clear_outstanding: "«Чистый непогашенный»",
    add_ip_whitelist: "Добавить белый список IP",
    bonus_issue_bulk: "Массовая выдача бонусов",
    edit_bank_member_ewallet: "Редактировать участника банка (электронный кошелек)",
    redeposit: "«Пополнить счет»",
    reject_approved_ticket: "Отклонить утвержденный билет",
    audit_ticket: "Билет аудита",
    review_ticket: "Обзор билета",
    edit_promotion_group_norm_seq: "Управление последовательностью продвижения в группе",
    edit_promo_provider_list: "Редактировать список поставщиков рекламных акций",
    edit_promo_payment_option: "Редактировать вариант оплаты промоакции",
    edit_campaign_provider_list: "Редактировать список поставщиков кампаний",
    update_comm: "Комиссия по обновлению",
    update_carry_over: "Перенос обновления",
    review_affiliate_ticket: "Обзор партнерского билета",
    audit_affiliate_ticket: "Аудиторский партнерский билет",
    get_tac_affiliate: "Получить OTP (Affiliate)",
    raise_deposit_ticket_gateway: "Поднять депозитный билет (шлюз)",
    direct_audit_ticket: "Заявка на аудит (прямая)",
    get_rollback_detail: "Получить сведения об откате",
    get_reject_detail: "Получить детали об отказе",
    manual_approve_ticket: "Утвердить заявку (вручную)",
    add_label: "Добавить метку",
    edit_label: "Редактировать метку",
    rollback_processing_ticket: "Откат обработки тикета",
    update_iframe_url: "Обновить URL-адрес iframe",
    edit_exchange_rate: "Редактировать обменный курс",
    add_vip: "Добавить VIP",
    add_turnover_tier: "Добавить уровень оборота",
    edit_turnover_tier: "Редактировать уровень оборота",
    get_member_label_list: "Список меток участников",
    add_rescue_fund: "Добавить спасательный фонд",
    get_custom_member_list: "Пользовательский список участников",
    get_rescue_fund_provider: "Получить поставщика спасательного фонда",
    add_game_exclude: "Добавить исключение из игры",
    delete_game_exclude: "Удалить исключение игры",
    domain_custom_add_assign: "Добавить домен",
    add_domain_batch: "Добавить домен (пакет)",
    update_payment_provider_vip: "Обновить платежного провайдера Vip",
    update_campaign: "Кампания обновления",
    purchase_domain: "Покупка домена",
    apply_domain: "Подать заявку на домен",
    edit_access_control: "Редактировать контроль доступа",
    add_domain: "Добавить домен",
    operator_wallet_adjust: "Adjust Operator Wallet",
    update_payment_provider_desc: "Обновить описание поставщика платежных услуг",
    add_package: "ui.add @:ui.package",
    edit_package: "ui.edit @:ui.package",
    add_theme_content: "ui.add @:ui.theme_content",
    edit_theme_content: "ui.edit @:ui.theme_content",
    add_theme: "ui.add @:ui.theme",
    edit_theme: "ui.edit @:ui.theme",
    add_color: "ui.add @:ui.color",
    edit_color: "ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Настройка логотипа",
    add_livechat: "@:ui.livechat",
    update_livechat: "@:ui.livechat",
    provider_pt_operator_update: "Обновление оператора PT провайдера",
    provider_pt_global_update: "Глобальное обновление провайдера PT",
    payment_option_callback_update: "Обновление URL обратного вызова",
    change_payment_option_seq: "Последовательность вариантов оплаты",
    change_payment_mode_status: "Обновление статуса способа оплаты",
    change_payment_option_recommend: "Рекомендация по варианту оплаты",
    change_payment_option_credential: "«Учетные данные для способа оплаты»",
    change_payment_option_limit: "Лимит вариантов оплаты",
    change_payment_option_vip: "Вариант оплаты VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners"
  },
  short: {
    deposit_amount: "Dep Amt",
    base_amount: "База Амт",
    bonus_amount: "Бонус Амт",
    target_amount: "Trgt Amt",
    knockoff_by: "K.O By",
    knockoff_date: "K.O Date",
    incoming_threshold: "IN THRES",
    incoming_frequency: "IN FREQ",
    outgoing_threshold: "OUT THRES",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC БАЛ",
    claim_type: "C.Тип",
    bonus_rate: "B.Rate",
    max_bonus: "M.Бонус",
    rollover: "«Ролловер»",
    criteria: "Критерии",
    start_time: "S.Time",
    end_time: "E.Time",
    monday: "MOH",
    tuesday: "ТИ",
    wednesday: "CP",
    thursday: "THU",
    friday: "ПТ",
    saturday: "SAT",
    sunday: "СОЛНЦЕ",
    status: "Статус",
    bonus_rate_percent: "B.Rate (%)",
    valid_turnover: "V.Оборот",
    deposit_count: "Dep Cnt",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "Wdw Cnt",
    adjustment_amount: "Adj Amt",
    referee_count: "Рефери Цнт",
    signup_count: "Зарегистрироваться Cnt",
    verified_count: "VRF Count",
    active_member: "Active Mbm",
    ftd_count: "FTD Cnt",
    ftd_amount: "FTD Amt",
    working_date: "Рабочий ДТ",
    recipient_bank_id: "R.Bank ID",
    recipient_bank_acc_no: "R.Bank Acc No.",
    recipient_bank_acc_holder: "R.Bank Acc Holder",
    sender_bank: "C.Банк",
    sender_bank_acc_no: "S.Bank Acc No.",
    sender_bank_acc_holder: "Держатель счета S.Bank",
    unique_login_count: "U.Login Cnt",
    unique_deposit_count: "U.Dep Cnt",
    unique_withdrawal_count: "U.Wdw Cnt",
    second_deposit_count: "S.Dep Cnt",
    reject_date: "R.Date",
    processing_date: "P.Date",
    deposit_withdrawal_different: "Dep Wdw Diff",
    external_id: "Ex. ID",
    draft_version: "«Сквозняк. Bep.»",
    prod_version: "Prod. Ver.",
    purchased_date: "P. Date",
    completed_amount: "Compl Amt"
  },
  date_ranges: {
    0: "Сегодня",
    1: "«Вчера»",
    2: "«В этом месяце»",
    4: "Прошлый месяц",
  },
  langList: {
    EN: "«Английский»",
    CN: "«китайцы»",
    PHP: "Philippines",
    esp: "Español",
    RUS: "Русский"
  },
  menulist: {
    home: "«Дом»",
    hot: "«Горячий»",
    slot_game: "«Слот»",
    casino: "«Казино»",
    sportsbook: "«Спорт»",
    fishing: "«Рыбалка»",
    lottery: "«Лотерея»",
    poker: "«Покер»",
    hash_game: "«Игра в Hash»",
    sabong: "Сабонг",
    promotion: "«Продвижение»",
    review: "Обзор",
    news: "Новости",
    live_stream: "Прямая трансляция",
    vip: "VIP",
    referral: "«Реферал»",
    favourite: "«Фаворитка»",
    mission: "Миссия (Мини Игра)",
    spin: "«Спин»",
    leaderboard: "Таблица лидеров",
    account: "Аккаунт",
    deposit: "«Депозит»",
    withdrawal: "«Вывод средств»",
    bet_history: "История ставок",
    pending_status: "Статус ожидания",
    change_password: "Изменить пароль",
    profile: "Профиль",
    banking_details: "«Банковские реквизиты»",
    inbox: "Входящие",
    voucher: "Ваучер",
    wallet: "«Кошелек»",
    statement: "Заявление",
    download: "Скачать",
    game: "«Игра»",
    special: "«Специальный»",
    misc: "Разное",
    contact_us: "Свяжитесь c нами",
    e_sportsbook: "Киберспортсбук",
    lotto: "«Лото»",
    p2p: "P2P",
    other: "Другое",
    vip2: "VIP2",
    referral2: "Peфepaл2",
    event: "Событие",
    daily_reward: "Ежедневная награда",
    play2earn: "Play 2 Earn",
    redemption: "«Искупление»",
    card_board: "«картонная доска»",
    lobby: "Лобби",
    in_house: "B доме",
    transfer: "«Перевод»",
    horse_racing: "«Скачки»",
    register: "Регистрация",
    login: "Войти",
    transaction_history: "«История транзакций»",
    bingo: "«Бинго»",
    member: "Участник",
    arcade: "«Аркада»",
    crash: "«Авария»"
  },

  ok: "OK",
  cancel: "Отмена",
  login: "Войти",
  logout: "Выйти",
  add: "Добавить",
  edit: "Редактировать",
  delete: "Удалить",
  refresh: "Обновить",
  action: "«Действие»",
  id: "ID",
  name: "Имя",
  all: "Bce",
  search: "Поиск",
  remove: "Удалить",
  save: "«Сохранить»",
  account: "Аккаунт",
  settings: "«Настройки»",
  on: "ВКЛ",
  off: "ВЫКЛ",
  new: "«Новый»",
  clear: "«Чистый»",
  users: "Пользователь | Пользователи»",
  username: "Имя пользователя",
  password: "«Пароль»",
  created_on: "Создать на",
  active: "«Активный»",
  page_size: "Размер страницы",
  status: "Статус",
  result: "Результат",
  close: "Закрыть",
  back: "Назад",
  show: "Показать",
  login_id: "Логин ID",
  date_time: "DateTime",
  ip_address: "ip-адрес",
  domain_name: "Доменное имя",
  browser_agent: "Агент браузера",
  action_by: "Action By",
  details: "Подробнее",
  key: "Ключ | Клавиши»",
  value: "Ценность | Ценности»",
  from: "Из",
  to: "Кому",
  type: "Тип",
  criteria: "Критерии",
  log: "Бревно",
  report: "Отчет",
  security_tag: "«Защитная метка»",
  security_code: "«Код безопасности»",
  submit: "Отправить",
  disable: "«Отключить»",
  operators: "Оператор | Операторы»",
  members: "Участники",
  account_id: "Идентификатор учетной записи",
  confirm_password: "Подтвердить пароль",
  full_name: "Полное имя",
  contact_phone: "Контактный телефон",
  contact_email: "Контактный адрес электронной почты",
  dashboard: "Приборная панель",
  sub_account: "Субсчет",
  authority_option: "«Опция полномочий»",
  banks: "Банк | Банки»",
  login_ip : "Логин IP",
  block: "«Блок»",
  profile_id: "ID профиля",
  suspend: "Приостановить",
  dob: "ДОБ",
  mail_address: "Почтовый адрес",
  deposit: "«Депозит»",
  withdrawal: "«Вывод средств»",
  rejected: "«Отвергнут»",
  processed: "«Обработанный»",
  pending: "B ожидании",
  member: "Участник",
  amount: "Сумма",
  bank_acc_no: "Номер банковского счета",
  deposit_date: "Дата депонирования",
  deposit_method: "«Способ депозита»",
  approve: "Утвердить",
  reject: "«Отвергнуть»",
  remark: "Ремарка",
  ticket_detail: "Детали билета",
  promo: "Промо",
  package: "Пакет",
  created_date: "Дата создания",
  currency: "«Валюта»",
  bank_acc_holder: "Держатель банковского счета",
  ref_no: "Номер ссылки",
  vip: "VIP",
  modified_date: "Дата изменения",
  modified_by: "Изменено",
  bank_member: "«Член Банка»",
  bank_operator: "«Оператор банка»",
  bank_name: "«Название банка»",
  bank_acc_type: "Тип банковского счета",
  account_balance: "Баланс счета",
  threshold: "«Порог»",
  incoming: "«Входящие»",
  outgoing: "«Исходящие»",
  frequency: "Частота",
  reset_threshold: "C6poc порога",
  adjust_balance: "«Отрегулировать баланс»",
  bank_from: "Банк из",
  bank_to: "Банк K",
  attachment: "«Вложение»",
  sender_bank: "Банк отправителя",
  sender_bank_acc_no: "Номер счета банка отправителя",
  sender_bank_acc_holder: "Держатель счета банка отправителя",
  audit: "«Аудит»",
  action_status: "Статус действия",
  action_date: "Дата действия",
  promotion: "«Продвижение»",
  promo_id: "Промо ID",
  promo_name: "Промо-название",
  package_id: "Идентификатор пакета",
  claim_type: "Тип формулы изобретения",
  bonus_rate: "Бонусная ставка",
  max_bonus: "Максимальный бонус",
  rollover: "«Ролловер»",
  start_date: "Дата начала",
  end_date: "Дата окончания",
  adj_amount: "Отрегулировать сумму",
  promotion_member: "Участник акции",
  on_going: "«На ходу»",
  knock_off: "Knock Off",
  all_ongoing: "Bce продолжается",
  deposit_amount: "Сумма депозита",
  base_amount: "Базовая сумма",
  bonus_amount: "Бонус Амт",
  target_amount: "«Целевая сумма»",
  claim_date: "Дата подачи заявки",
  accumulate_win: "«Накапливай выигрыш»",
  accumulate_turnover: "«Накапливать оборот»",
  bonus: "Бонус",
  bonus_log: "Бонусный журнал",
  member_id: "Идентификатор участника",
  before_balance: "«До баланса»",
  transfer_amount: "Сумма перевода",
  after_balance: "После баланса",
  created_by: "Создано",
  bonus_name: "Название бонуса",
  bonus_desc: "Описание бонуса",
  bonus_type: "Тип бонуса",
  add_promo: "Добавить продвижение",
  bonus_value: "Бонусная стоимость",
  attach_promo: "Прикрепить рекламу",
  daily_statement: "«Ежедневная выписка»",
  working_date: "Рабочая дата",
  opening_balance: "«Начальный баланс»",
  turnover: "«Оборот»",
  valid_turnover: "Действительный оборот",
  winlose: "WinLose",
  withdrawal_amount: "«Сумма вывода»",
  closing_balance: "Заключительный баланс",
  sub_total: "Промежуточный итог",
  grand_total: "Гранд Тотал",
  daily_winlose: "Дейли Уинлос",
  game_result_slots: "Результат игры (слоты)",
  game_result_livecasino: "Результат игры (Livecasino)",
  game_result_rebate: "Результат игры (рибейт)",
  game_result_sportsbook: "Результат игры (букмекер)",
  game_result_cockfight: "Результат игры (Петушиные бои)",
  game_result_rescue: "Результат игры (Спасение)",
  bet_count: "Подсчет ставок",
  result_id: "ID результата",
  bet_time: "Время ставки",
  payout: "«Выплата»",
  game_type: "Тип игры",
  game_name: "Название игры",
  game_provider: "Провайдер игр",
  reset: "«Сброс»",
  mode: "Режим",
  balance: "«Баланс»",
  min_bal_knock_off_promo: "Min Bal. (To auto knock off promotion)",
  social_account: "«Социальный аккаунт»",
  wechat: "Wechat",
  telegram: "Телеграмма",
  whatsapp: "«Ватсап»",
  facebook: "Фейсбук",
  instagram: "«Инстаграм»",
  login_log: "Журнал входа",
  platform: "«Платформа»",
  bank_statement: "«Выписка c банковского счета»",
  transfer_date: "«Дата переноса»",
  detail: "Деталь",
  date: "«Свидание»",
  transfer_list: "«Список переводов»",
  credit: "Кредит",
  debit: "«Дебет»",
  month: "Месяц",
  unblock: "Разблокировать",
  unblock_member: "Разблокировать участника",
  unblock_operator: "Разблокировать оператора",
  referrer_id: "Идентификатор реферера",
  referrer_code: "Код реферера",
  referral_code: "Реферальный код",
  bonus_and_adjustment: "Бонусы и корректировки",
  adjustment: "«Регулировка»",
  incoming_amount_threshold: "Порог входящей суммы",
  outgoing_amount_threshold: "Порог исходящей суммы",
  knock_off_by: "Knock Off By",
  knock_off_date: "Knock Off Date",
  total_turnover: "«Общий оборот»",
  total_winlose: "Total Winlose",
  total_deposit: "Общий депозит",
  total_member: "Общий член",
  active_player: "Активный игрок",
  top_winner: "Лучший победитель",
  top_loser: "Топ",
  winner: "Победитель",
  loser: "Неудачник",
  deposit_count: "Количество депозитов",
  withdrawal_count: "Счетчик выводов",
  alert: "Алерт",
  incoming_threshold: "Порог входа",
  incoming_frequency: "Входящая частота",
  outgoing_threshold: "Исходящий порог",
  outgoing_frequency: "Исходящая частота",
  reset_password: "«Сбросить пароль»",
  transfer: "«Перевод»",
  company_bank: "«Компания Банк»",
  company_bank_acc_no: "Регистрационный номер банковского счета",
  company_bank_acc_holder: "Держатель банковского счета компании",
  registered_member: "Зарегистрированный Участник",
  promotion_report: "«Отчет o продвижении»",
  deposited_member: "Депонированный участник",
  referred_member: "«Приглашенный участник»",
  validated_on: "Проверено на",
  first_deposit: "«Первый депозит»",
  reward: "«Награда»",
  inbox: "Входящие",
  manual_bonus: "Ручной бонус",
  review: "Обзор | Отзывы»",
  reviews: "Отзывы",
  review_list: "«Список обзоров»",
  review_detail: "Детали обзора",
  reply_review: "Ответить на отзыв",
  comment: "Комментарий",
  reply: "Ответить",
  recipient_no: "Номер получателя",
  question : "Вопрос",
  rating: "Рейтинг",
  content: "«Контент»",
  image: "«Изображение»",
  monthly_rating: "«Ежемесячный рейтинг»",
  affiliate: "«Партнер»",
  affiliate_list: "Партнерский список",
  affiliate_code: "Партнерский код",
  approved_by: "Утверждено",
  approved_date: "Утвержденная дата",
  bank_affiliate: "Филиал банка",
  bank_id: "«Банковский ID»",
  ticket_detail_affiliate: "Партнер по деталям билетов",
  pending_application: "«Заявка на рассмотрении»",
  pending_review_withdrawal: "«Ожидание и пересмотр вывода средств»",
  unblock_affiliate: "Разблокировать партнера",
  wallet_adjust: "Настройка кошелька",
  comm_package: "Коммуникационный пакет",
  affiliate_id: "Партнерский ID",
  sub_account_detail: "Сведения о дополнительной учетной записи",
  daily_winlose_affiliate: "Daily Winlose (Affiliate)",
  daily_deposit_affiliate: "Ежедневный депозит (партнерский)",
  export_excel: "Экспорт Excel",
  get_tac: "Получить OTP",
  tac_code: "OTP код",
  expiry_date: "Дата истечения срока действия",
  inactive: "«Неактивный»",
  last_deposit_date: "Дата последнего депозита",
  coupon: "«Купон»",
  allocated: "Выделено",
  claimed: "«Заявлено»",
  approved: "Утверждено",
  coupon_code: "Код купона",
  coupon_quota: "«Купонная квота»",
  current_allocated: "Текущее распределение",
  new_allocated: "Новое распределение",
  update : "Обновление",
  copy: "Копировать",
  bonus_rate_percent : "Бонусная ставка (%)",
  coupon_desc: "Описание купона",
  both: "«И то, и другое»",
  issue_free_spin: "Выдать фриспин",
  game: "«Игра»",
  max_win_amount: "Максимальная сумма выигрыша",
  utm_list: "Список UTM",
  search_by_member: "Поиск по участнику",
  campaign: "«Кампания»",
  deposited: "«Депонированный»",
  search_by_id: "Поиск по ID",
  get_bank_tac: "Получить Bank OTP",
  bank_statement_daily: "Выписка c банковского счета (ежедневная)",
  transfer_type: "«Тип перевода»",
  audit_freebies_list: "Список бесплатных для аудита",
  acknowledge: "Подтвердить",
  submit_acknowledgement: "Отправить подтверждение",
  is_ack: "Is Ack",
  yes: "Да",
  no: "Нет",
  audit_rescue_fund_list: "Список Фонда спасения от аудита",
  global_setting: "Глобальная обстановка",
  signup_ip: "IP-адрес регистрации",
  last_login_ip: "IP последнего входа",
  last_login_time: "Время последнего входа в систему",
  link: "Звено",
  is_default: "is default",
  is_public: "является публичным",
  bank_group: "«Банковская группа»",
  set_default: "Установить по умолчанию",
  group_id: "Идентификатор группы",
  group_name: "Название группы",
  provider_maintenance: "«Обслуживание провайдера»",
  provider_code: "Код провайдера",
  provider_name: "Название поставщика",
  withdrawal_limit: "Лимит на снятие средств",
  limit_id: "Идентификатор лимита",
  limit_name: "Название лимита",
  daily_amount: "«Суточное количество»",
  daily_frequency: "«Ежедневная частота»",
  promotion_id: "ID промоакции",
  promotion_name: "«Название акции»",
  withhold_bonus: "Удержание бонуса",
  withhold_amount: "Удержание суммы",
  withhold_amt: "Удержать Амт",
  max_withdraw_amt: "Max Withdraw Amt",
  max_withdraw_amount: "Максимальная сумма вывода",
  monday: "«Понедельник»",
  tuesday: "Вторник",
  wednesday: "«Среда»",
  thursday: "Четверг",
  friday: "Пятница",
  saturday: "«Суббота»",
  sunday: "«Воскресенье»",
  start_time: "Время начала",
  end_time: "«Конец времени»",
  day: "День | Дни»",
  coupon_status: "«Статус купона»",
  campaign_id: "ID кампании",
  campaign_name: "Название кампании",
  promotion_group: "Промоушен Групп",
  referee_list: "«Рецензентский список»",
  account_verified: "«Аккаунт верифицирован»",
  verified_date: "Проверенная дата",
  ticket_list: "«Список билетов»",
  vip_id: "VIP ID",
  vip_name: "VIP имя",
  self_rebate_rate: "Ставка самовозврата (%)",
  downline_rebate_rate: "Нижестоящая ставка рибейта (%)",
  provider: "Провайдер",
  match_id: "Match ID",
  home_team: "Домашняя команда",
  away_team: "Гостевая команда",
  home_team_new: "Домашняя команда Новая",
  away_team_new: "Гостевая команда Новая",
  updated_by: "Обновлено",
  updated_on: "Обновлено",
  home_score: "Домашний счет",
  away_score: "Счет в гостях",
  home_score_new: "Home Score New",
  away_score_new: "Выездной счет новый",
  team: "«Команда»",
  match_time: "Время матча",
  match_round: "Матчевой раунд",
  home_group: "Домашняя группа",
  away_group: "Выездная группа",
  match: "Матч",
  match_status: "Статус матча",
  insert: "Вставить",
  pin: "«Булавка»",
  bet_list: "Список ставок",
  result_list: "Список результатов",
  bet_id: "ID ставки",
  bet_home: "Ставка домой",
  bet_away: "Ставка на исход",
  bet_on: "Ставка на",
  min_deposit: "Минимальный депозит",
  min_withdrawal: "Минимальный вывод средств",
  raise_deposit_ticket: "Поднять депозитный билет",
  method: "«Метод»",
  one_time_depositor: "Одноразовый вкладчик",
  current_month_non_depositor: "Недепозитор в текущем месяце",
  current_month_no_login: "Текущий месяц без входа в систему",
  ticket_date: "«Дата билета»",
  ftd_amount: "FTD Amt",
  bonus_issue: "Бонусная эмиссия",
  promotion_summary: "Резюме акции",
  promotion_summary_detail: "Краткое описание акции (подробности)",
  claim_frequency: "Частота претензий",
  provider_list: "«Список поставщиков»",
  platform_winlose: "Платформа Winlose",
  adjustment_amount: "Сумма корректировки",
  referee_count: "Счет судей",
  category: "«Категория»",
  update_vip: "Обновить VIP",
  promotion_signup: "Регистрация в акции",
  provider_bet_limit: "Лимит ставок провайдера",
  update_member_bet_limit: "Обновить лимит ставок участника",
  bet_limit: "Лимит ставки",
  sports_game: "Спорт/Игра",
  league_name: "Название лиги",
  home_team_name: "Название домашней команды",
  away_team_name: "Название гостевой команды",
  wl_status: "Статус Winlose",
  available_bank_account: "«Доступный банковский счет»",
  group_bank_account: "Групповой банковский счет",
  edit_bank_group: "Edit Bank Group",
  edit_bank_account_group: "Редактировать группу банковских счетов",
  redeposit: "«Пополнить счет»",
  upline: "«Вышестоящий»",
  downline: "Нижестоящий",
  available_promotion: "«Доступная акция»",
  group_promotion: "«Продвижение группы»",
  edit_promotion_group: "Редактировать группу продвижения",
  edit_promotion_group_norm: "Управление продвижением в группе",
  balance_before: "«Баланс до»",
  balance_after: "Balance After",
  signup_count: "Количество регистраций",
  verified_count: "Проверенный подсчет",
  active_member: "«Активный участник»",
  ftd_count: "FTD Count",
  daily_summary_company: "Ежедневная сводка (Компания)",
  daily_summary_operator: "Ежедневная сводка (Оператор)",
  daily_summary_member: "Ежедневная сводка (Участник)",
  daily_ledger_operator: "Ежедневная бухгалтерская книга (оператор)",
  bonus_list: "«Список бонусов»",
  ltd_date: "LTD Date",
  adjustment_log: "«Журнал регулировки»",
  get_inbox: "Получить входящие",
  is_claimed: "является заявленным",
  mix_parlay: "Микс Парлай",
  event: "Событие",
  result_changes_log: "Журнал изменений результатов",
  view_detail: "Просмотреть подробности",
  total_referee: "Общий судья",
  verified_signup: "Проверено / Зарегистрироваться",
  ftd: "FTD | Первый Разовый Депозит",
  raw_msg: "Сырое сообщение",
  unselect_all: "Отменить выделение всех",
  select_all: "Выбрать все",
  edit_bet_limit: "Редактировать лимит ставки",
  provider_game_off: "Provider Game Off",
  provider_hot_game: "Провайдер Hot Game",
  game_id : "Game ID",
  game_list: "Список игр",
  off_list: "Вне списка",
  provider_rtp: "Провайдер RTP",
  rtp: "RTP",
  signup_date: "Дата регистрации",
  free_credit: "Бесплатный кредит",
  downline_rebate: "Нижестоящий рибейт",
  game_rebate: "Game Rebate",
  rebate: "Рибейт",
  ftd_date: "FTD Date",
  provider_winlose_company: "Провайдер Winlose (Компания)",
  provider_winlose_operator: "Провайдер Winlose (оператор)",
  already_hit: "«уже попали»",
  ongoing: "«Текущий»",
  members_export: "Участник (Экспорт)",
  get_recent_deposit: "Получить недавний депозит",
  recent_deposit: "Недавний депозит",
  survey_list: "«Опросный лист»",
  modified_on: "Modified On",
  cms: "CMS",
  announcement_banner: "Баннер объявления",
  promotion_banner: "«Рекламный баннер»",
  slide_banner: "Слайд Баннер",
  seo_page: "SEO-страница",
  en_title: "Title (EN)",
  cn_title: "Титул (CN)",
  local_title: "Название (MECTHOE)",
  en_img: "Изображение (EN)",
  cn_img: "Изображение (CN)",
  local_img: "Изображение (ЛОКАЛЬНОЕ)",
  before_login: "Перед входом в систему",
  after_login: "После входа в систему",
  en: "EN",
  move_up: "«Движение вверх»",
  move_down: "Move Down",
  banner_type: "Тип баннера",
  default_order: "Ордер по умолчанию",
  item_order: "Заказ товара",
  title: "Название",
  banner_id: "Идентификатор баннера",
  order: "Заказ",
  body: "«Тело»",
  en_image: "Изображение (EN)",
  local_image: "Изображение (ЛОКАЛЬНОЕ)",
  move: "«Двигайся»",
  en_img_desktop: "Image Desktop (EN)",
  cn_img_desktop: "Рабочий стол c изображением (CN)",
  local_img_desktop: "Рабочий стол c изображением (ЛОКАЛЬНЫЙ)",
  en_img_mobile: "Имидж Мобайл (EN)",
  cn_img_mobile: "Имидж Мобиль (CN)",
  local_img_mobile: "Имидж Мобильный (ЛОКАЛЬНЫЙ)",
  login_required: "Требуется вход в систему",
  new_window_tab: "Новое окно / вкладка",
  current_page: "Текущая страница",
  target: "«Мишень»",
  alt: "Alt",
  href: "Хреф",
  image_desktop: "Образ рабочего стола",
  image_mobile: "Мобильное изображение",
  en_alt: "Alt (EN)",
  local_alt: "Alt (LOCAL)",
  en_href: "Href (EN)",
  local_href: "Href (LOCAL)",
  en_image_desktop: "Образ рабочего стола (EN)",
  active_period: "«Активный период»",
  en_item: "Товар (EN)",
  local_item: "Товар (ЛОКАЛЬНЫЙ)",
  meta_title: "Мета Титул",
  meta_keywords: "Мета-ключевые слова",
  meta_url: "Мета URL",
  meta_canonical: "Мета Канонический",
  meta_author: "Мета Автор",
  meta_publisher: "Мета Паблишер",
  meta_lang: "Мета Ланг",
  meta_desc: "Мета Деск",
  meta_image: "Мета Имидж",
  page: "Страница",
  item: "Предмет",
  remove_desktop_image: "Удалить образ рабочего стола",
  remove_mobile_image: "Удалить изображение c мобильного устройства",
  page_name: "Имя страницы",
  login_date: "Дата входа",
  ftd_amount_min: "Минимальная сумма FTD",
  ftd_amount_max: "Максимальная сумма FTD",
  fl_provider_code: "Провайдер первого запуска",
  fl_game_id: "ID игры при первом запуске",
  fl_game_name: "Имя игры при первом запуске",
  top_deposit: "Топ Депозит",
  top_withdrawal: "Вывод средств из топа",
  top_promotion: "«Топ Продвижение»",
  outstanding_balance: "«Выдающийся баланс»",
  last_update_time: "Время последнего обновления",
  trace: "След",
  trace_outstanding: "Выдающийся след",
  outstanding: "«Выдающийся»",
  clear_outstanding: "«Чистый непогашенный»",
  meta_image_url: "Мета URL изображения",
  member_bonus: "Бонус для участника",
  crm_list: "Список CRM",
  advance_search: "Предварительный поиск",
  deposit_count_from: "Подсчет депозитов c",
  deposit_count_to: "Подсчет депозитов",
  deposit_amount_from: "Сумма депозита из",
  deposit_amount_to: "Сумма депозита до",
  min_day_no_login: "Мин. день без входа в систему",
  min_day_no_deposit: "Мин. день без депозита",
  last_login: "Последний вход",
  last_deposit: "«Последний депозит»",
  phone: "«Телефон»",
  email: "Электронная почта",
  ip_whitelist: "Белый список IP",
  ip: "ИП",
  payment_option: "«Способ оплаты»",
  payment_mode: "«Платежный режим»",
  payment_desc: "Платежный счет",
  edit_provider: "Провайдер редактирования",
  success: "«УСПЕХ»",
  failed: "HE УДАЛОСЬ",
  bank_member_ewallet: "Участник банка (Электронный кошелек)",
  processing: "«Обработка»",
  recipient_bank_id: "«Идентификатор банка получателя»",
  recipient_bank_acc_no: "Номер счета банка получателя",
  ticket_auto_withdrawal_log: "Журнал билетов (Автоматический вывод средств)",
  resubmit_ticket: "Отправить заявку повторно",
  ticket_export: "Билет (Экспорт)",
  export_deposit: "Экспорт (Депозит)",
  export_deposit_all: "Экспортировать все (Депозит)",
  export_withdrawal: "Экспорт (Вывод)",
  export_withdrawal_all: "Экспортировать все (выводить)",
  export_member_all: "Экспортировать всех (Участник)",
  processed_rejected: "Обработано (Отклонено)",
  channel: "«Канал»",
  influencer: "Инфлюенсер",
  ticket_id: "ID билета",
  recommend: "Рекомендую",
  sequence: "Последовательность",
  statement_info: "Информация o выписке",
  slots: "«Слоты»",
  livecasino: "Livecasino",
  sportsbook: "«Букмекерская контора»",
  cockfight: "«Петушиный бой»",
  member_list: "Список участников",
  operator: "Оператор",
  game_balance: "«Игровой баланс»",
  claim_limit: "Лимит претензий",
  max_withdraw_multiple: "Max Withdraw Multiple",
  payment_gateway: "Платежный шлюз",
  min_limit: "Минимальный предел",
  max_limit: "Максимальный лимит",
  total: "Итого",
  rebate_summary: "Сводка по скидкам",
  rebate_summary_daily: "Ежедневная сводка по скидкам",
  rebate_member: "Участник co скидкой",
  self: "«Я»",
  system_balance: "«Баланс системы»",
  rejected_onload: "Отклонено (Onload)",
  no_bonus: "Без бонуса",
  audit_ticket: "Билет аудита",
  review_ticket: "Обзор билета",
  edit_promotion_group_norm_seq: "Управление последовательностью продвижения в группе",
  signup_bonus: "Бонус за регистрацию",
  settlement_type: "Тип поселения",
  carry_over: "Перенос",
  comm_sports: "Комиссия (Спорт)",
  comm_slots: "Комиссия (Слоты)",
  comm_livecasino: "Комиссия (Livecasino)",
  comm_cockfight: "Комиссия (Петушиный бой)",
  comm_others: "Комиссия (Прочие)",
  update_comm: "Комиссия по обновлению",
  update_carry_over: "Перенос обновления",
  ewallet: "«Электронный кошелек»",
  withdrawal_list: "Список вывода",
  audit_withdrawal: "«Отзыв из аудита»",
  daily_withdrawal: "«Ежедневный вывод средств»",
  adjustment_log_affiliate: "«Журнал регулировки»",
  daily_statement_affiliate: "Ежедневный отчет (Партнер)",
  earning: "«Заработок»",
  pnl: "P&L",
  review_affiliate_ticket: "Обзор партнерского билета",
  audit_affiliate_ticket: "Аудиторский партнерский билет",
  turnover_downline: "Оборот (нижестоящая структура)",
  valid_turnover_downline: "Действительный оборот (нижестоящая структура)",
  winlose_downline: "WinLose (Downline)",
  bet_count_downline: "Подсчет ставок (нижестоящая линия)",
  turnover_member: "Оборот (Участник)",
  valid_turnover_member: "Действительный оборот (участник)",
  winlose_member: "WinLose (Участник)",
  bet_count_member: "Подсчет ставок (Участник)",
  dashboard_affiliate: "Личный кабинет (Партнер)",
  total_agent: "Total Agent",
  top_turnover: "«Топ оборота»",
  bonus_count: "Подсчет бонусов",
  deposit_amount_downline: "Сумма депозита (нижестоящая структура)",
  deposit_count_downline: "Количество депозитов (нижестоящая линия)",
  bonus_amount_downline: "Сумма бонуса (нижестоящая структура)",
  bonus_count_downline: "Подсчет бонусов (нижестоящая линия)",
  deposit_amount_member: "Сумма депозита (Участник)",
  deposit_count_member: "Количество депозитов (Участник)",
  bonus_amount_member: "Сумма бонуса (Участник)",
  bonus_count_member: "Количество бонусов (Участник)",
  verified: "«Проверено»",
  round_id: "Круглый ID",
  unfinish_round: "Незаконченный раунд",
  smartico_bonus_report: "Отчет о бонусах Smartico",
  unclaimed_amount: "«Невостребованная сумма»",
  claimed_amount: "Заявленная сумма",
  unclaimed_count: "«Невостребованный граф»",
  claimed_count: "Заявленный подсчет",
  submit_time: "Дата создания",
  deposit_time: "Дата изменения",
  funds_list: "«Список билетов»",
  daifu_list_auto_withdrawal: "Список билетов (Автоматический вывод средств)",
  btn_href: "Баттон Греф",
  btn_text: "Текст кнопки",
  recent_inbox_claim: "Недавняя претензия в папкеВходящие",
  raise_deposit_ticket_gateway: "Поднять депозитный билет (шлюз)",
  gateway_acc: "Учетная запись шлюза",
  provider_winlose_member: "Провайдер Winlose (Участник)",
  review_by: "Рецензирование",
  daifu_list_auto_withdrawal_export: "Экспорт билетов (Автоматический вывод)",
  retention: "Ретентон",
  current_month_active_user: "Активный пользователь текущего месяца",
  current_month_active: "Активный текущий месяц",
  first_month: "«Первый месяц»",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "Сумма FMDeposit",
  cohort: "«Когорта»",
  promotion_withdrawal_summary: "«Сводка по выводу средств по акции»",
  unique_player: "«Уникальный игрок»",
  year: "Год | лет»",
  audit_time_modified: "Дата изменения",
  audit_time_created: "Дата создания",
  approve_time: "Дата изменения",
  unique_login_count: "Уникальный счетчик входов",
  unique_deposit_count: "Уникальный подсчет депозитов",
  unique_withdrawal_count: "Уникальный счетчик выводов",
  second_deposit_count: "Подсчет второго депозита",
  unique_login: "Уникальный логин",
  unique_withdrawal: "«Уникальный вывод средств»",
  second_deposit: "«Второй депозит»",
  deposit_withdrawal_different: "Вывод депозита другой",
  ngr: "NGR",
  audit_list: "«Список аудита»",
  rollback_count: "Счетчик откатов",
  rejected_ticket_id: "Идентификатор отклоненного билета",
  rollback: "«Откат»",
  recipient_bank_acc_holder: "Держатель банковского счета получателя",
  reject_date: "Отклонить дату",
  processing_date: "Дата обработки",
  manual_approve: "Утвердить (вручную)",
  pending_review_funds: "Ожидающий и рассмотренный тикет",
  table_id: "Идентификатор стола",
  member_label: "Метка участника",
  label_name: "Название лейбла",
  label: "«Этикетка»",
  available_label: "Доступная этикетка",
  iframe: "Iframe",
  iframe_url: "URL-адрес iframe",
  exchange_rate: "«Обменный курс»",
  rate: "«Ставка»",
  rate_php: "Rate PHP",
  ticket_withdrawal_rollback: "Откат вывода билета",
  smartico_bonus_report_expired: "Отчет o бонусах Smartico (срок действия)",
  reward_type: "Тип награды",
  turnover_rebate: "«Рибейт за оборот»",
  turnover_rebate_1: "VIP уровень",
  turnover_rebate_2: "«Уровень оборота»",
  vip_cycle_day: "VIP Cycle Day",
  is_addon: "Is Addon",
  no_reward: "«Без награды»",
  cash: "«Наличные»",
  cs: "«Обслуживание клиентов»",
  social_platform: "«Социальная платформа»",
  edit_vip: "Редактировать VIP",
  edit_vip_provider: "Редактировать VIP-провайдера",
  turnover_tier: "«Уровень оборота»",
  rebate_rate: "Ставка рибейта",
  edit_turnover_tier: "Редактировать уровень оборота",
  delete_turnover_tier: "Удалить уровень оборота",
  vip_log: "VIP журнал",
  member_full_record: "Полный послужной список участника",
  before: "До",
  after: "После",
  maintain: "Поддерживать",
  actual_rebate: "Фактический рибейт",
  rounded_rebate: "«Округленная скидка»",
  rebate_mode: "Режим рибейта",
  inbox_id: "Идентификатор папкиВходящие",
  rebate_type: "Тип рибейта",
  promotion_type: "Тип акции",
  bonus_rate_1: "Ставка 1(%)",
  bonus_rate_2: "Ставка 2(%)",
  bonus_rate_3: "Ставка 3(%)",
  bonus_rate_4: "Ставка 4(%)",
  bonus_rate_5: "Ставка 5(%)",
  bonus_rate_6: "Ставка 6(%)",
  bonus_rate_7: "Ставка 7(%)",
  bonus_rate_8: "Ставка 8(%)",
  bonus_rate_9: "Ставка 9(%)",
  bonus_rate_10: "Ставка 10(%)",
  delete_all: "Удалить все",
  rescue_fund: "«Фонд спасения»",
  up: "Вверх",
  down: "Вниз",
  rate_percent: "Ставка %",
  cycle: "«Цикл»",
  actual_amount: "Фактическая сумма",
  rounded_amount: "округленная сумма",
  rescue_id: "«Спасательный ID»",
  rescue_name: "Имя спасателя",
  min_lose: "Min Lose",
  max_payout: "Максимальная выплата",
  payout_method: "«Способ выплаты»",
  target_group: "«Целевая группа»",
  member_vip_id: "VIP ID участника",
  daily: "«Ежедневно»",
  weekly: "«Еженедельник»",
  monthly: "«Месячный»",
  edit_batch: "Редактировать пакет",
  current_level: "Текущий уровень",
  next_level: "«Следующий уровень»",
  bet_value: "Стоимость ставки",
  line_bet: "Ставка на линию",
  total_round: "Общий раунд",
  audit_by: "Аудит по",
  possible_next_level: "Возможный следующий уровень",
  maintain_deposit: "Поддерживать депозит",
  maintain_turnover: "«Поддержание оборота»",
  starting_deposit: "«Стартовый депозит»",
  starting_turnover: "Стартовый оборот",
  cycle_deposit: "Циклический депозит",
  cycle_turnover: "«Цикл оборота»",
  vip_list: "VIP список",
  up_maintain: "Up Maintain",
  down_lowest: "Вниз по низу",
  manual: "«Ручной»",
  daily_winlose_game: "Daily Winlose (Game)",
  actionaff: "Действие (Партнер)",
  onload: "onload",
  update_status: "Обновить статус",
  role_settings: "Настройки ролей",
  customer_services: "«Обслуживание клиентов»",
  marketing: "«Маркетинг»",
  finance: "«Финансы»",
  risk_management: "«Управление рисками»",
  pt: "ПТ",
  wallet_history: "История кошелька",
  ticket_amount: "«Сумма билета»",
  ignore_risk: "«Игнорировать риск»",
  permitted_amount: "«Разрешенная сумма»",
  all_pending_ticket: "Bce ожидающие рассмотрения билеты",
  rescue_fund_summary: "Сводка Фонда спасения",
  rescue_fund_summary_daily: "Сводка Фонда спасения за день",
  rescue_fund_member: "Член Фонда Спасения",
  master: "«Мастер»",
  account_type: "Тип аккаунта",
  freeze: "«Заморозка»",
  domain_member_setup: "Настройка домена пользовательского сайта",
  domain: "Домен",
  domain_list: "Список доменов",
  domain_application: "Заявка на домен",
  domain_status: "Статус домена",
  domain_group: "Доменная группа",
  operator_id: "Идентификатор оператора",
  domain_type: "Тип домена",
  module: "Модуль",
  template: "Шаблоны",
  custom: "«Пользовательский»",
  default: "По умолчанию",
  payment_provider: "«Поставщик платежных услуг»",
  payment: "«Оплата»",
  deactivate: "«Неактивный»",
  name_server: "Сервер имен",
  server_account: "Учетная запись сервера",
  service_provider: "«Поставщик услуг»",
  process: "Процесс",
  provider_operator: "«Оператор-провайдер»",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Глобальные настройки",
  second_id: "«Второе удостоверение личности»",
  unverified: "«Непроверенный»",
  pt_affiliate: "Комиссии партнерской платформы (%)",
  recipient_bank: "«Банк-получатель»",
  deposit_type: "Тип депозита",
  security_fund: "«Фонд безопасности»",
  adjust_balance_op: "Adjust Operator Wallet",
  adjust_security_deposit_op: "Скорректировать Фонд Безопасности Оператора",
  marquee: "Шатер",
  marquee_content: "«Шатеровое содержимое»",
  edit_marquee: "Редактировать шатер",
  domain_available: "Домен доступен",
  daily_withdrawal_frequency: "Ежедневная частота вывода",
  maintenance: "«Техническое обслуживание»",
  max_withdrawal: "Максимальный вывод средств",
  min_balance: "«Минимальный остаток»",
  affiliate_report: "Партнерские отчеты",
  cash_balance: "«Остаток денежных средств»",
  copy_success: "Успешно скопируйте!",
  copy_failed: "Копирование не удалось!",
  your_website: "«Ваш сайт»",
  correction_promo: "Коррекция (Продвижение)",
  others: "Другие",
  audit_log: "Журнал аудита",
  view: "Вид",
  price: "Цена",
  package_level: "Уровень пакета",
  bo_right: "БО Прав",
  english: "«Английский»",
  simplified_chinese: "Китайский (CN)",
  traditional_chinese: "Китайский (TW)",
  philippine: "«Филиппинский»",
  thai: "«Тайский»",
  vietnamese: "«вьетнамский»",
  indonesian: "«индонезийский»",
  myanmar: "«Мьянма»",
  japanese: "«японский»",
  korean: "«Корейский»",
  package_type: "Тип упаковки",
  full_back_office_access_right: "Полное право доступа к бэк-офису",
  read_only_back_office: "Бэк-офис Readonly",
  language: "«Язык»",
  lang_code: "Код языка",
  description: "Описание",
  provider_type: "«Тип поставщика»",
  logo: "«Логотип»",
  theme_provider: "Поставщик тем",
  theme_content: "Содержимое темы",
  content_id: "Content ID",
  content_desc: "Описание контента",
  theme_content_position: "Позиция контента темы",
  theme: "«Тема»",
  theme_code: "Код темы",
  theme_name: "Название темы",
  color: "«Цвет»",
  position: "Должность",
  site_name: "Название сайта",
  theme_color: "Цвет темы",
  theme_purchased: "Тема куплена",
  total_purchased: "Bcero куплено",
  purchased_date: "«Купленная дата»",
  purchase: "«Купить»",
  total_site: "Общий сайт",
  content_setup: "Настройка контента",
  site_list: "Список сайтов",
  site_id: "Идентификатор сайта",
  draft_version: "Черновой вариант",
  prod_version: "Прод. версия",
  production_version: "Производственная версия",
  info: "Инфо",
  setting: "«Настройка»",
  site_info: "Информация o сайте",
  menu: "Меню",
  game_menu: "Игровое меню",
  special_menu: "Специальное меню",
  setting_menu: "Меню настроек",
  error: "Ошибка",
  sync_all: "Синхронизировать все",
  theme_content_group: "Тематическая группа контента",
  content_group: "Контент-группа",
  content_group_desc: "Content Group Desc",
  parent_content_id: "Идентификатор родительского контента",
  bo_default_domain: "Домен BO по умолчанию",
  domain_id: "ID домена",
  deactive: "«Деактивный»",
  site_sync: "Синхронизация сайта",
  upload: "Загрузить",
  comingSoon: "Скоро",
  profile_setting: "«Настройка профиля»",
  bank: "Банк",
  company: "Компания",
  own: "СОБСТВЕННЫЙ",
  operator_setting: "«Настройка оператора»",
  external_id: "Внешний идентификатор",
  ticket: "Билет",
  bank_owner: "«Владелец банка»",
  exchanged_currency: "Обмениваемая валюта",
  company_bank_owner: "«Владелец банка компании»",
  ticket_list_member: "Список билетов (Участник)",
  game_name_exclude: "Исключить игровое имя",
  tab: "Вкладка",
  about_us: "O нас",
  privacy_policy: "«Политика конфиденциальности»",
  responsible_gaming: "«Ответственная игра»",
  banking: "«Банковское дело»",
  faqs: "Часто задаваемые вопросы",
  advertisement: "Реклама",
  px_pixel_id: "PX Pixel ID",
  px_token: "Токен PX",
  af_dev_key: "Ключ для разработки",
  af_apps_id: "af apps id",
  pp_tid: "ПП ТИД",
  pp_pid: "PP PID",
  pp_aid: "PP AID",
  gtm_id: "GTM ID",
  service_provider_url: "URL-адрес поставщика услуг",
  script_inject: "Script Inject",
  head_script: "«Сценарий головы»",
  body_script: "Body Script",
  ads_id: "Идентификатор объявления",
  member_detail: "Сведения o члене",
  memberreport: "Отчет участника",
  member_log: "Журнал участника",
  general: "Генерал",
  top_theme: "Топ Тема",
  hot_game: "«Горячая игра»",
  hot_list: "«Горячий список»",
  new_game: "Новая игра",
  popular_game: "Популярная игра",
  featured_game: "Избранная игра",
  new_list: "Новый список",
  popular_list: "Популярный список",
  featured_list: "Избранное",
  provider_new_game: "Провайдер Новая Игра",
  provider_popular_game: "Провайдер Популярная Игра",
  provider_featured_game: "Рекомендуемая игра провайдера",
  website: "«Веб-сайт»",
  site_customization: "«Кастомизация сайта»",
  export_all: "Экспортировать все",
  export_one: "Экспорт (текущая страница)",
  daily_ledger: "«Ежедневная бухгалтерская книга»",
  daily_ledger_member: "Ежедневная бухгалтерская книга (Участник)",
  promotion_signup_unused: "«Неиспользованная акция при регистрации»",
  promotion_signup_ongoing: "Текущая акция по регистрации",
  promotion_signup_winlose: "Акция при регистрации Winlose",
  promotion_signup_winlose_operator: "Акция на регистрацию Winlose (Оператор)",
  promotion_signup_winlose_member: "Акция за регистрацию Winlose (Member)",
  total_player_balance: "Общий баланс игрока",
  search_all: "Поиск все",
  mbsetting: "«Настройки»",
  todays_highlights: "Основные моменты сегодняшнего дня",
  deposit_player: "Депозитный игрок",
  withdrawal_player: "Игрок на вывод средств",
  kill_rate: "Процент убийств",
  login_player: "Вход в игру",
  operation_management: "Эксплуатация",
  game_management: "«Игра»",
  member_management: "Участник",
  affiliate_management: "«Партнер»",
  promotion_management: "«Продвижение»",
  mbcampaign: "«Кампания»",
  promo_allday: "«Весь день»",
  promo_daily: "«Ежедневно»",
  promo_daily_first_deposit: "Ежедневный первый депозит",
  promo_deposit_monthly: "Ежемесячный подсчет депозитов",
  promo_deposit_signup: "Регистрация для подсчета депозитов",
  promo_deposit_weekly: "«Еженедельный подсчет депозитов»",
  promo_newbie: "Новичок",
  promo_once: "«Однажды»",
  dd_review: "Обзор",
  game_provider_management: "Провайдер",
  exchanged_amount: "Сумма обмена",
  operator_summary: "Сводка по оператору",
  business_id: "Business ID",
  game_name_exclude_log: "Исключение лога игрового имени",
  cn: "CN",
  local: "«МЕСТНЫЙ»",
  taken: "«Взятый»",
  receiver_bank: "«Банк-получатель»",
  receiver_bank_acc_no: "Номер счета банка получателя",
  receiver_bank_acc_holder: "Держатель счета банка-получателя",
  add_balance: "Добавить баланс",
  deduct_balance: "Вычесть остаток",
  sync_site_content: "Синхронизация содержимого сайта",
  payment_setting: "«Настройка платежей»",
  payment_own: "СОБСТВЕННЫЙ",
  payment_global: "ГЛОБАЛЬНЫЙ",
  livechat: "LiveChat",
  chat_id: "Лицензионный ключ LiveChat",
  chat_provider: "Провайдер LiveChat",
  auto_cycle: "«ЦИКЛ»",
  auto_all: "BCE",
  completed_amount: "Завершенная сумма",
  website_launched: "Сайт запущен",
  total_operators: "Total Operators",
  today_active: "Сегодня активный",
  new_player_verified_signup: "Новый игрок верифицирован/зарегистрирован",
  total_players: "Общее количество игроков",
  depo_withdrawal_diff: "ДЕПО-C Отличием",
  claim_count: "Подсчет претензий",
  ggr: "GGR",
  member_balance: "Баланс участника",
  players: "Игроки",
  provider_pt: "Провайдер PT",
  base: "«База»",
  topup_id: "Topup ID",
  credential: "Учетные данные",
  credential_1: "Квалификация 1",
  credential_2: "Удостоверение 2",
  credential_3: "Удостоверение 3",
  credential_4: "Удостоверение 4",
  credential_5: "Удостоверение 5",
  credential_6: "Удостоверение 6",
  credential_7: "Удостоверение 7",
  credential_8: "Квалификация 8",
  credential_9: "Удостоверение 9",
  credential_10: "Квалификация 10",
  limit: "«Лимит»",
  create: "Создать",
  hint: "Подсказка",
  quickSetup: "Быстрая настройка",
  next: "Далее",
  setUpTheme: "Настройка темы",
  checkOut: "Выписываться",
  standardPackage: "«Стандартный пакет»",
  siteName: "Название сайта",
  information: "Информация",
  useThisTemplate: "Использовать этот шаблон",
  summary: "Резюме",
  createOperatorAccount: "Создать учетную запись оператора",
  operatorId: "Идентификатор оператора",
  operatorPwd: "Пасссор оператора",
  new_website: "Новый сайт",
  operator_information: "«Информация для оператора»",
  bo_link: "БО Линк",
  daily_summary_sms: "Ежедневные сводные SMS",
  daily_summary_sms_operator: "Оператор ежедневной сводки SMS",
  daily_summary_sms_operator_detail: "Ежедневная сводка по SMS Реквизит оператора",
  sms_count: "Подсчет SMS",
  provider_winlose_operator_pt: "Провайдер Winlose (Оператор PT)",
  pt_on: "PT On",
  share_operator: "Оператор акции",
  share_company: "Акционерная компания",
  token_log: "Лог токенов",
  template_code: "Код шаблона",
  template_name: "Имя шаблона",
  mini_game: "Мини игра",
  max_game_reward: "Максимальная награда за игру",
  max_chance_per_day: "Максимальный шанс в день",
  is_recurring_chance: "«Повторяющийся»",
  token_request: "«Жетон»",
  enabled: "Включено",
  disabled: "«Инвалид»",
  unlimited: "Безлимитный",
  max_chance_unlimited: "Максимальный шанс в день без ограничений",
  mini_game_template: "Шаблон мини-игры",
  reward_code: "«Код вознаграждения»",
  reward_name: "Название награды",
  reward_description: "Описание награды",
  reward_probability: "«Вероятность вознаграждения»",
  total_game: "Тотальная игра",
  total_played_mini_game: "Bcero сыграно в мини-игру",
  total_played_mini_game_detail: "Общая деталь сыгранной мини-игры",
  total_played_mini_game_detail_operator: "Общая информация o сыгранной мини-игре (оператор)",
  daily_pnl_operator: "Ежедневный P&L (Оператор)",
  token: "«Жетон»",
  token_1: "Токен 1",
  token_2: "Жетон 2",
  token_3: "Жетон 3",
  token_4: "Жетон 4",
  token_5: "Жетон 5",
  token_6: "Жетон 6",
  token_7: "Жетон 7",
  cash_1: "Наличные 1",
  cash_2: "«Наличные 2»",
  cash_3: "Наличные 3",
  cash_4: "Наличные 4",
  cash_5: "Наличные 5",
  cash_6: "Наличные 6",
  cash_7: "Наличные 7",
  daily_login: "Ежедневный заезд (ежедневный вход)",
  daily_login_update: "Ежедневное обновление регистрации (ежедневного входа)",
  game_result_reward: "Результат игры (награда)",
  current_streak: "Current Streak",
  login_streak: "Полоса входа",
  total_token: "«Общий токен»",
  total_mini_game_token_used: "«Всего использован жетон для мини-игр»",
  total_mini_game_token_used_detail: "Общая информация o6 используемом токене мини-игры",
  total_mini_game_token_used_detail_operator: "«Общая информация o6 используемом токене мини-игры (оператор)»",
  total_reward: "Общая награда",
  total_mini_game_reward: "Общая награда за мини-игру",
  total_mini_game_reward_detail: "Общая информация o награде за мини-игру",
  total_mini_game_reward_detail_operator: "Общая информация o награде в мини-игре (оператор)",
  token_balance: "Баланс токенов",
  free_game_token: "Жетон бесплатной игры",
  bo_url: "Бэкофис URL",
  copied: "Скопирован",
  callback: "Обратный звонок",
  api: "API",
  prefix: "Приставка",
  delimiter: "«Разделитель»",
  url_callback_deposit: "URL обратного вызова депозита",
  url_callback_withdrawal: "URL обратного вызова на вывод средств",
  url_callback_affiliate: "URL партнерского оповещения",
  url_api_deposit: "URL обратного вызова депозита (API)",
  url_api_withdrawal: "URL обратного вызова вывода средств (API)",
  url_api_balance: "Баланс URL обратного вызова (API)",
  prefix_deposit: "Префикс депозита",
  prefix_withdrawal: "«Префикс вывода средств»",
  prefix_affiliate: "Партнерский префикс",
  prefix_delimiter: "Префикс разделителя",
  merchant: "Торговец",
  app_id: "App ID",
  secret_key: "«Секретный ключ»",
  deposit_secret_key: "Секретный ключ депозита",
  withdrawal_secret_key: "Секретный ключ для вывода средств",
  partners: "Партнеры",
  partner_name: "Имя партнера",
  win: "Победа",
  manifest: "«Манифест»",
  crop: "«Кроп»",
  cropImage: "«Обрезать изображение»",
  api_url: "URL API",
  start_date_time: "Дата и время начала",
  end_date_time: "Дата и время окончания",
  authentication_key: "Ключ аутентификации",
  one_week: "1 неделя",
  two_week: "2 недели",
  one_month: "1 месяц",
  two_month: "2 месяца",
  six_month: "6 месяцев",
  edit_promotion_end_date: "Редактировать дату окончания акции",
  android_app_link: "Ссылка на приложение Android",
  add_android_app_link: "Добавить ссылку на приложение Android",
  operator_details: "Данные оператора",
  bsb: "BSB",
  payid: "Pay ID",
  cuit: "CUIT",
  merchant_key: "Ключ продавца",
  aes_key: "AES ключ",
  paycode: "Платёжный код",
  api_key: "API ключ",
  referral: "Реферальная ссылка",
  minimum_deposit: "Минимальный депозит",
  minimum_withdrawal: "Минимальный вывод",
  maximum_withdrawal: "Максимальный вывод"
}